export type Driving = {
    brandPage: Record<string, string>
    reviewsPage: Record<string, string>
    reviewsHubPage: Record<string, string>
    sellYourCar: Record<string, string>
    topVehiclesPage: Record<string, string>
    inventoryListing: Record<string, string>
    financingTool: Record<string, string>
    shoppingTools: Record<string, string>
    topVehiclesOptionsPage: Record<string, string>
    findCompare: Record<string, string>
    modelCard: Record<string, string>
    vehicleCard: Record<string, string>
    myPicks: Record<string, string>
    modelPage: Record<string, string>
    comparisonResults: Record<string, string>
    vehicleSortForm: Record<string, string>
    vehicleFinder: Record<string, string>
    vehicleDualComparisonPage: Record<string, string>
    vehicleTrimComparisonPage: Record<string, string>
    vehicleFinderForm: Record<string, string>
    trimSelector: Record<string, string>
}
export type Header = {
    share: Record<string, string>
    menu: Record<string, string>
    menuDriving: Record<string, string>
    scroll: Record<string, string>
    search: Record<string, string>
    searchMobile: Record<string, string>
}
type ImageService = {
    id: string
}
export type Main = {
    carousel: Record<string, string>
    characterCount: Record<string, string>
    copyLink: Record<string, string>
    dropdownChecklist: Record<string, string>
    formValidator: Record<string, string>
    focusInView: Record<string, string>
    gallery: Record<string, string>
    hideOnOverlap: Record<string, string>
    list: Record<string, string>
    memberContent: Record<string, string>
    modal: Record<string, string>
    myTopics: Record<string, string>
    myTopicsWidget: Record<string, string>
    popover: Record<string, string>
    readMore: Record<string, string>
    recaptcha: Record<string, string>
    recommendations: Record<string, string>
    savedArticles: Record<string, string>
    searchPage: Record<string, string>
    shareButton: Record<string, string>
    slider: Record<string, string>
    slidingDrawer: Record<string, string>
    smoothHashScroll: Record<string, string>
    storyComment: Record<string, string>
    savedArticlesPage: Record<string, string>
    myAccount: Record<string, string>
    featureBar: Record<string, string>
    htmx: Record<string, string>
    conversationStarter: Record<string, string>
    ageGate: Record<string, string>
}
type Native = Record<string, string>
type Page = {
    pageType: string
}
export type Subscription = {
    ccValidated: Record<string, string>
    eventPage: Record<string, string>
    auth: Record<string, string>
}
export type Video = {
    leadVideo: Record<string, string>
    playlist: Record<string, string>
    singlePlayer: Record<string, string>
    sticky: Record<string, string>
    videoCentre: Record<string, string>
    jwPlayerVertical: Record<string, string>
}
export type Widget = {
    iframe: Record<string, string>
    newsletter: Record<string, string>
    priceline: Record<string, string>
    sailthruPersonalizationEngine: Record<string, string>
    skimlinks: Record<string, string>
    trendingWidgetPositioner: Record<string, string>
    weather: Record<string, string>
    videoPlaylist: Record<string, string>
}
type Markets = {
    markets: Record<string, string>
}

export const ATTR_NAME: {
    driving: Driving
    header: Header
    imageService: ImageService
    main: Main
    native: Native
    page: Page
    subscription: Subscription
    video: Video
    widget: Widget
    markets: Markets
} = {
    driving: {
        findCompare: {
            _: 'data-find-compare-component',
            bodystyles: 'data-bodystyles',
            makes: 'data-makes',
            years: 'data-years',
            use_latest_year: 'data-use-latest-year',
            price_min: 'data-price-min',
            price_max: 'data-price-max',
            seats: 'data-seats',
            power_source: 'data-powersource',
            transmission: 'data-transmission',
            filter: 'data-filter',
            sort: 'data-sort'
        },
        modelCard: {
            _: 'data-model-card-component',
            year: 'data-model-card-year',
            make: 'data-model-card-make',
            model: 'data-model-card-model',
            vehicleCardID: 'data-vehicle-card-id'
        },
        vehicleCard: {
            _: 'data-vehicle-card-component',
            year: 'data-vehicle-card-year',
            make: 'data-vehicle-card-make',
            model: 'data-vehicle-card-model',
            vehicleCardID: 'data-vehicle-card-id'
        },
        myPicks: {
            _: 'data-my-pick-component',
            numVehicles: 'data-num-vehicle'
        },
        brandPage: {
            _: 'data-brand-page-component'
        },
        modelPage: {
            _: 'data-model-page-component'
        },
        reviewsPage: {
            _: 'data-reviews-page-component'
        },
        reviewsHubPage: {
            _: 'data-reviews-hub-page-component'
        },
        sellYourCar: {
            _: 'data-sell-your-car-component'
        },
        topVehiclesPage: {
            _: 'data-top-vehicles-page-component'
        },
        inventoryListing: {
            _: 'data-inventory-listing-component'
        },
        financingTool: {
            _: 'data-financing-tool-component'
        },
        shoppingTools: {
            _: 'data-shopping-tools-component'
        },
        topVehiclesOptionsPage: {
            _: 'data-top-vehicles-options-page-component'
        },
        comparisonResults: {
            _: 'data-comparison-results-component',
            scrollPanel: 'data-scroll-panel'
        },
        vehicleSortForm: {
            _: 'data-vehicle-sort-form'
        },
        vehicleFinder: {
            _: 'data-vehicle-finder-component',
            years: 'data-years'
        },
        vehicleDualComparisonPage: {
            _: 'data-vehicle-dual-comparison-page-component'
        },
        vehicleTrimComparisonPage: {
            _: 'data-vehicle-trim-comparison-page-component'
        },
        vehicleFinderForm: {
            _: 'data-vehicle-finder-form'
        },
        trimSelector: {
            vehicleId: 'data-vehicle-id'
        }
    },
    header: {
        share: {
            _: 'data-header-share-component'
        },
        menu: {
            _: 'data-header-menu-component',
            label: 'data-header-menu-label',
            target: 'data-header-menu-target',
            level: 'data-level'
        },
        menuDriving: {
            _: 'data-header-driving-menu-component'
        },
        scroll: {
            _: 'data-scroll-component'
        },
        search: {
            _: 'data-header-search-component'
        },
        searchMobile: {
            _: 'data-header-search-mobile-component'
        }
    },
    imageService: {
        id: 'container'
    },
    main: {
        carousel: {
            _: 'data-carousel-component',
            type: 'data-carousel-type',
            iconBtn: 'data-carousel-icon-button',
            slideList: 'data-carousel-slide-list',
            slideItem: 'data-carousel-item',
            prevBtn: 'data-carousel-prev',
            nextBtn: 'data-carousel-next',
            pageNumber: 'data-carousel-current-page',
            pageTotal: 'data-carousel-total-pages',
            paginationNav: 'data-carousel-paginate-controls',
            paginationNavToIndex: 'data-carousel-paginate-to-index'
        },
        characterCount: {
            _: 'data-character-count',
            maxLength: 'data-max-length',
            minLength: 'data-min-length',
            value: 'data-character-value'
        },
        copyLink: {
            _: 'data-copy-link'
        },
        dropdownChecklist: {
            _: 'data-dropdown-checklist',
            button: 'data-dropdown-checklist-button',
            fieldset: 'data-dropdown-checklist-set'
        },
        formValidator: {
            _: 'data-form-validator',
            error: 'data-formValidator-error',
            name: 'data-form-validator-name'
        },
        focusInView: {
            _: 'data-focus-in-view'
        },
        gallery: {
            _: 'data-gallery-component',
            errorModal: 'data-gallery-error-modal'
        },
        hideOnOverlap: {
            _: 'data-hide-on-overlap-component',
            targetSelector: 'data-hide-on-overlap'
        },
        list: {
            _: 'data-list-component',
            id: 'data-list-id',
            name: 'data-list-name',
            catSlug: 'data-list-cat-slug',
            slugsAccepted: 'data-list-slugs-accepted',
            slugsExcluded: 'data-list-slugs-excluded',
            url: 'data-list-url',
            originUrls: 'data-list-origin-urls',
            contentId: 'data-content-id',
            listFrom: 'data-list-from',
            listClass: 'data-list-class',
            type: 'data-list-type',
            render: 'data-list-render',
            maxItem: 'data-list-max',
            minItem: 'data-list-min',
            pos: 'data-list-pos',
            articleId: 'data-article-id',
            templateName: 'data-template-name',
            removeDuplication: 'data-remove-duplication',
            isSponsored: 'data-is-sponsored',
            nativeAdEnabled: 'data-list-native_ad_enabled',
            nativeAdCounter: 'data-list-native_ad_counter',
            bookmarkEnabled: 'data-bookmark-enabled'
        },
        memberContent: {
            _: 'data-member-content',
            memberType: 'data-member-type',
            memberOnly: 'data-member-only'
        },
        modal: {
            _: 'data-modal-component',
            modalClose: 'data-modal-close',
            modalControl: 'data-modal-control',
            modalUseBackdrop: 'data-modal-backdrop'
        },
        myTopics: {
            _: 'data-my-topics'
        },
        myTopicsWidget: {
            _: 'data-my-topics-widget-component'
        },
        popover: {
            _: 'data-popover-component',
            clickToAppear: 'data-click-to-appear',
            container: 'data-container',
            containerOffset: 'data-container-offset',
            tailOffset: 'data-tail-offset',
            tailPosition: 'data-tail-position',
            noStyle: 'data-no-style',
            position: 'data-position',
            sticky: 'data-sticky'
        },
        readMore: {
            _: 'read-more-component'
        },
        recaptcha: {
            _: 'data-recaptcha-component'
        },
        recommendations: {
            _: 'data-recommendations-component',
            id: 'data-recommendations-id'
        },
        savedArticles: {
            _: 'data-saved-articles-component'
        },
        searchPage: {
            _: 'data-search-component'
        },
        shareButton: {
            _: 'data-sharing',
            position: 'data-modal-position'
        },
        slider: {
            _: 'data-slider'
        },
        slidingDrawer: {
            _: 'data-sliding-drawer'
        },
        smoothHashScroll: {
            _: 'data-smooth-hash-scroll-component'
        },
        storyComment: {
            _: 'data-story-comment-component'
        },
        savedArticlesPage: {
            _: 'data-saved-articles-page-component'
        },
        myAccount: {
            _: 'data-my-account-component'
        },
        featureBar: {
            _: 'data-feature-bar'
        },
        htmx: {
            _: 'data-load-htmx'
        },
        conversationStarter: {
            _: 'data-sso-conversation-starter'
        },
        ageGate: {
            _: 'data-age-gate-component'
        }
    },
    native: {
        _: 'data-native',
        listPosition: 'data-list-position'
    },
    page: {
        pageType: 'data-page-type'
    },
    subscription: {
        ccValidated: {
            _: 'data-cc-validated-component'
        },
        eventPage: {
            _: 'data-event-page-component'
        },
        auth: {
            _: 'data-auth-component'
        }
    },
    video: {
        leadVideo: {
            _: 'data-lead-video-component'
        },
        playlist: {
            _: 'data-playlist-component',
            id: 'data-playlist-id',
            index: 'data-index',
            videoPlaylistId: 'data-video-playlist-id'
        },
        singlePlayer: {
            _: 'data-single-video-component'
        },
        sticky: {
            _: 'data-sticky-video-component',
            title: 'data-video-title'
        },
        videoCentre: {
            _: 'data-video-centre-component'
        },
        jwPlayerVertical: {
            _: 'data-jw-player-vertical-component'
        }
    },
    widget: {
        iframe: {
            _: 'data-widget-iframe-component',
            scriptUrl: 'data-url',
            title: 'data-title',
            width: 'data-width',
            height: 'data-height',
            scrolling: 'data-scrolling',
            allowPolicy: 'data-allow-policy',
            style: 'data-style'
        },
        newsletter: {
            _: 'data-newsletter-component',
            type: 'data-newsletter',
            total: 'data-newsletter-total',
            listId: 'data-target-list',
            accountId: 'data-account-id',
            authorName: 'data-author-name',
            exclusiveCta: 'newsletters-exclusive-cta'
        },
        priceline: {
            _: 'data-priceline-component'
        },
        sailthruPersonalizationEngine: {
            _: 'data-sailthru-personalization-engine-component',
            type: 'data-sailthru-personalization-engine',
            accountId: 'data-account-id'
        },
        skimlinks: {
            _: 'data-widget-skimlink-component',
            accountId: 'data-account',
            blackList: 'data-blacklist'
        },
        trendingWidgetPositioner: {
            _: 'data-trending-widget-component'
        },
        videoPlaylist: {
            id: 'widget_video_playlist'
        },
        weather: {
            _: 'data-widget-weather-component',
            region: 'region',
            city: 'city'
        }
    },
    markets: {
        markets: {
            _: 'data-markets-component'
        }
    }
}
